import { render } from "./ExternalUnitIssuanceReportsTab.vue?vue&type=template&id=ef4fcbee"
import script from "./ExternalUnitIssuanceReportsTab.vue?vue&type=script&lang=js"
export * from "./ExternalUnitIssuanceReportsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__